/* eslint-disable */
export default {
  noActiveCalls: 'Nessuna chiamata attiva',
  noRecords: 'Nessun risultato trovato.',
} as const;

// @key: @#@"noActiveCalls"@#@ @source: @#@"No active calls"@#@
// @key: @#@"noRecords"@#@ @source: @#@"No results found."@#@
